<template>
<div class="content-body tenant-settings">
    <div class="">
        <el-form :inline="true" size="mini" :model="dataForm" @keyup.enter.native="getDataList()">
            <!--<el-form-item label="人均劳务费:">
                <el-input size="mini" v-model="dataForm.perCapitaLaborCosts" placeholder="人均劳务费" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <el-form-item label="折旧年数:">
                <el-input size="mini" v-model="dataForm.yearsOfDepreciation" placeholder="折旧年数" clearable @blur="getDataList"></el-input>
            </el-form-item>-->

            <el-form-item label="制造工序名称:">
                <el-input size="mini" v-model="dataForm.manufacturingProcess" placeholder="制造工序名称" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <el-form-item class="fr">
              <el-button type="primary" size="mini"  @click="showquotationConversionSuppMat()">
                辅助材料
              </el-button>
              <el-button size="mini" :loading="saveDisabled" type="primary" v-if="isAuth('portal:quotation:newbuttonDetail') && viewFlag !== 'view'"  plain @click="save()">
                <span class="font-12 iconfont myicon-tongguo"></span>&nbsp;保存
              </el-button>
                <el-button size="mini" @click="getDataList()" icon="el-icon-search">
                    查询
                </el-button>
<!--                <el-button size="mini" v-if="isAuth('portal:quotation:newbuttonDetail') && viewFlag !== 'view'" type="primary" plain @click="addOrUpdateHandle()" icon="el-icon-plus">-->
<!--                    新建-->
<!--                </el-button>-->
              <el-button size="mini" v-if="isAuth('portal:quotation:newbuttonDetail') && viewFlag !== 'view'" type="primary" plain @click="addHandleNewRow()" icon="el-icon-plus">
                新增
              </el-button>
                <!-- <el-button size="mini" v-if="isAuth('sys:org:savebutton')" type="primary" @click="addOrUpdateHandle()" icon="el-icon-plus">
                    导入订单
                </el-button> -->
            </el-form-item>
        </el-form>
        <div v-loading="dataListLoading">
          <el-table-edit
              v-model="dataList"
              :columns="['manufacturingProcess','roundNo', 'theNumberOfDirect','perCapitaLaborCosts'
          ,'personnelProportion','labor','investment','yearsOfDepreciation','annualStartTime','depreciationPerHour','auxiliaryMaterials','summation']"
              ref="editTable"
          >
            <el-table :data="dataList" row-key="id" size="mini" border bProject style="width: 100%;" :default-expand-all="false" :header-cell-style="{background:'#f5f5f5'}" :height="tableHeight">
                <el-table-column type="index" width="50" label="序号">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                    </template>
                </el-table-column>
                <el-table-column prop="manufacturingProcess" header-align="center" width="200" align="left" label="制造工序名称">
                  <template slot-scope="{ row }">
                    <el-table-edit-cell
                        :row="row"
                        prop="manufacturingProcess"
                    >
                      <template slot-scope="{ rowStates}">
                        <span v-show="!rowStates.editing">{{row.manufacturingProcess}}</span>
                        <el-input
                            size="mini"
                            v-show="rowStates.editing"
                            v-model="row.manufacturingProcess"
                            clearable
                        >
                        </el-input>
                      </template>
                    </el-table-edit-cell>
                  </template>
                </el-table-column>
                <el-table-column prop="theNumberOfDirect" header-align="center" width="100" align="right" label="直接人数(A)">
                  <template slot-scope="{ row }">
                    <el-table-edit-cell
                        :row="row"
                        prop="theNumberOfDirect"
                    >
                      <template slot-scope="{ rowStates}">
                        <span v-show="!rowStates.editing">{{row.theNumberOfDirect}}</span>
                        <ctl-number :precision="4" :min="0" v-show="rowStates.editing" v-model="row.theNumberOfDirect" maxlength="200"></ctl-number>
                      </template>
                    </el-table-edit-cell>
                  </template>
                </el-table-column>
                <el-table-column prop="perCapitaLaborCosts" header-align="center" align="right" width="160" label="人均劳务费(元/小时)(B)">
                  <template slot-scope="{ row }">
                    <el-table-edit-cell
                        :row="row"
                        prop="perCapitaLaborCosts"
                    >
                      <template slot-scope="{ rowStates}">
                        <span v-show="!rowStates.editing">{{row.perCapitaLaborCosts | digit3}}</span>
                        <ctl-number :precision="4" :min="0" v-show="rowStates.editing" v-model="row.perCapitaLaborCosts" maxlength="200"></ctl-number>
                      </template>
                    </el-table-edit-cell>
                  </template>
                </el-table-column>
                <el-table-column prop="personnelProportion" header-align="center" align="right" width="160" label="间接制造人员比例%(C)">
                  <template slot-scope="{ row }">
                    <el-table-edit-cell
                        :row="row"
                        prop="personnelProportion"
                    >
                      <template slot-scope="{ rowStates}">
                        <span v-show="!rowStates.editing">{{row.personnelProportion | digit3}}%</span>
                        <ctl-number :precision="4"  :max="100" :min="0" v-show="rowStates.editing" v-model="row.personnelProportion" maxlength="200"></ctl-number>
                      </template>
                    </el-table-edit-cell>
                  </template>
                </el-table-column>
                <el-table-column prop="labor" header-align="center" align="right" width="230" label="每小时劳务费(元/小时)D=A*B*(1+C)">
                    <template slot-scope="scope">
                        {{scope.row.labor | digit3}}
                    </template>
                </el-table-column>
                <el-table-column prop="investment" header-align="center" align="right" width="100" label="投资额(E)">
                  <template slot-scope="{ row }">
                    <el-table-edit-cell
                        :row="row"
                        prop="investment"
                    >
                      <template slot-scope="{ rowStates}">
                        <span v-show="!rowStates.editing">{{row.investment | digit3}}</span>
                        <ctl-number :precision="4" :min="0" v-show="rowStates.editing" v-model="row.investment" maxlength="200"></ctl-number>
                      </template>
                    </el-table-edit-cell>
                  </template>
                </el-table-column>
                <el-table-column prop="yearsOfDepreciation" header-align="center" align="right" width="100" label="折旧年数(F)">
                  <template slot-scope="{ row }">
                    <el-table-edit-cell
                        :row="row"
                        prop="yearsOfDepreciation"
                    >
                      <template slot-scope="{ rowStates}">
                        <span v-show="!rowStates.editing">{{row.yearsOfDepreciation | digit3}}</span>
                        <ctl-number :precision="4" :min="0" v-show="rowStates.editing" v-model="row.yearsOfDepreciation" maxlength="200"></ctl-number>
                      </template>
                    </el-table-edit-cell>
                  </template>
                </el-table-column>
                <el-table-column prop="annualStartTime" header-align="center" align="right" width="170" label="每年开工时间(小时/年)(G)">
                  <template slot-scope="{ row }">
                    <el-table-edit-cell
                        :row="row"
                        prop="annualStartTime"
                    >
                      <template slot-scope="{ rowStates}">
                        <span v-show="!rowStates.editing">{{row.annualStartTime | digit3}}</span>
                        <ctl-number :precision="4" :min="0" v-show="rowStates.editing" v-model="row.annualStartTime" maxlength="200"></ctl-number>
                      </template>
                    </el-table-edit-cell>
                  </template>
                </el-table-column>
                <el-table-column prop="depreciationPerHour" header-align="center" align="right" width="220" label="每小时折旧费(元/小时) H=E/(F*G)">
                    <template slot-scope="scope">
                        {{scope.row.depreciationPerHour | digit3}}
                    </template>
                </el-table-column>
                <el-table-column prop="auxiliaryMaterials" header-align="center" align="right" width="210" label="公用动力辅助材料等(元/小时) (I)">
                  <template slot-scope="{ row }">
                    <el-table-edit-cell
                        :row="row"
                        prop="auxiliaryMaterials"
                    >
                      <template slot-scope="{ rowStates}">
                        <span v-show="!rowStates.editing">{{row.auxiliaryMaterials | digit3}}</span>
                        <ctl-number :precision="4" :min="0" v-show="rowStates.editing" v-model="row.auxiliaryMaterials" maxlength="200"></ctl-number>
                      </template>
                    </el-table-edit-cell>
                  </template>
                </el-table-column>
                <el-table-column prop="summation" header-align="center" align="right" width="160" label="合计(元/小时) J=D+H+I">
                    <template slot-scope="scope">
                        {{scope.row.summation | digit3}}
                    </template>
                </el-table-column>
                <el-table-column prop="roundNo" width="150" header-align="center" align="right" label="报价轮次">
                </el-table-column>
                <el-table-column header-align="center" align="left" width="190" fixed="right" label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" v-show="scope.row.id !==''" @click="viewHandle(scope.row)" icon="el-icon-view">
                            查看
                        </el-button>
                        <el-button type="text" size="small" v-show="scope.row.id !==''" :disabled="viewFlag != 'view'? false :true" @click="addOrUpdateHandle(scope.row)" icon="el-icon-edit">
                            修改
                        </el-button>
                        <el-button type="text" size="small" :disabled="viewFlag != 'view'? false :true" @click="deleteHandle(scope.row)" icon="el-icon-delete" class="button-danger">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
          </el-table-edit>
            <!-- 分页 -->
            <!-- <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20,50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
            </el-pagination> -->
        </div>
        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
        <!-- 弹窗, 辅助材料 -->
<!--        <quotationConversionSuppMat v-if="quotationConversionSuppMatVisible" ref="QuotationConversionSuppMat"></quotationConversionSuppMat>-->
        <quotationConversionSuppMat ref="QuotationConversionSuppMat" v-if="quotationConversionSuppMatVisible"></quotationConversionSuppMat>
    </div>
</div>
</template>

<script>
import {
  editRfqQuotationConversionBatch,
  createRfqQuotationConversionBatch,
  getQuotationDetail
} from '@/controller/quotation'
import {
    fetchRfqQuotationConversion,
    removeRfqQuotationConversion
} from '@/controller/quotation'
import AddOrUpdate from './quotationConversion-add-or-update'
import quotationConversionSuppMat from './quotationConversion-supplementary-materials'
import moment from 'moment'
import CtlNumber from '@/views/common/ctl-number'
// require('@/mock/mockContract');
export default {
    props: {
        roundNo: Number,
        dataFromParent: Object
    },
    data() {
        return {
            documentClientHeight: document.documentElement['clientHeight'] - 250,
            dataForm: {
              rfqId: '',
              rfqPartId: '',
              rfqSupplierId: '',
              roundNo: '',
              perCapitaLaborCosts: '',
              investment: '',
              manufacturingProcess:''
            },
            viewFlag: '',
            dataList: [],
            pageIndex: 1,
            pageSize: 10,
            saveDisabled:false,
            totalPage: 0,
            dataListLoading: false,
            dataListSelections: [],
            addOrUpdateVisible: false,
            quotationConversionSuppMatVisible:false,
        }
    },
    computed: {
      editTable() {
        return this.$refs.editTable
      },
        tableHeight: {
            get() {
                return this.$store.state.common.documentClientHeight - 270
            }
        }
    },
    components: {
        AddOrUpdate,
        CtlNumber,
        quotationConversionSuppMat
    },
    filters:{
      digit3:function (data){
          if (data  ==0 ){
            return data
          }
          data = Number(data).toFixed(3)
          if(Number.isNaN(Number(data))){
            return null
        }
        return Number(data)
        },
    },
    activated() {
        this.getDataList()
    },
    methods: {
      showquotationConversionSuppMat(){
        this.quotationConversionSuppMatVisible = true;
        var id=null;
        this.$nextTick(() => {
          this.$refs.QuotationConversionSuppMat.init(id, this.viewFlag, this.dataForm)
        });
      },
      //新一行
      getNewRowData() {
        return {
          'id':'',
          'rfqId': this.dataForm.rfqId,
          'rfqPartId': this.dataForm.rfqPartId,
          'rfqSupplierId': this.dataForm.rfqSupplierId,
          'manufacturingProcess':'',
          'theNumberOfDirect':'',
          'perCapitaLaborCosts':'',
          'personnelProportion':'',
          'labor':'',
          'investment':'',
          'yearsOfDepreciation':'',
          'annualStartTime':'',
          'depreciationPerHour':'',
          'auxiliaryMaterials':'',
          'summation':'',
          'roundNo':this.dataForm.roundNo!==null ? this.dataForm.roundNo:'0',
          'rowNum':this.rowNum
        }
      },
      // 新增行
      addHandleNewRow() {
        const newRow = this.getNewRowData()
        this.editTable.newRows([newRow])
        this.rowNum += 1
      },
        dateFormat: function (row, column) {
            var date = row[column.property]
            if (date == undefined) {
                return ''
            }
            return moment(date).format("YYYY-MM-DD HH:mm:ss")
        },
        // 新增或编辑子节点
        // addChildHandle(id, parentId, parentName, parentNodePath) {

        //     console.log(id, parentId, parentName, parentNodePath)
        //     this.addOrUpdateVisible = true
        //     this.$nextTick(() => {
        //         this.$refs.addOrUpdate.init(null, parentId, parentName, parentNodePath)
        //     })
        // },
        init(rfqId = 0, rfqPartId = 0, supplierId = 0, roundNo = 0, viewFlag) {
            this.dataForm.rfqId = rfqId
            this.dataForm.rfqSupplierId = supplierId
            this.dataForm.rfqPartId = rfqPartId
            this.dataForm.roundNo = this.roundNo
            this.viewFlag = viewFlag
            this.pageIndex = 1
            this.getDataList()
        },
        // 获取数据列表
        getDataList() {
            this.dataListLoading = true
            debugger
            fetchRfqQuotationConversion({
                pageNo: 1,
                pageSize: -1,
                "rfqId":this.dataForm.rfqId,
                "rfqPartId":this.dataForm.rfqPartId,
                "rfqSupplierId":this.dataForm.rfqSupplierId,
                "roundNo":this.dataForm.roundNo,
                'manufacturingProcess': this.dataForm.manufacturingProcess
            }).then(data => {
                console.log(data, 'data')
                if (data && data.code === '00') {
                    this.dataList = data.body.records
                    this.totalPage = data.body.total
                } else {
                    this.dataList = []
                    this.totalPage = 0
                }
            }).catch((e) => {
                console.log(e)
            }).finally(() => {
                this.dataListLoading = false
            })
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val
            this.pageIndex = 1
            this.getDataList()
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val
            this.getDataList()
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val
        },
        // 查看
        viewHandle(row) {
            let id = row ? row.id : null;
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(id, 'view', this.dataForm, this.dataFromParent.rfqId)
            })
        },
        // 新增 / 修改
        addOrUpdateHandle(row) {
            let id = row ? row.id : null;
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(id, 'edit', this.dataForm, this.dataFromParent.rfqId)
            })
        },
        // 删除
        deleteHandle(row) {
            var id  = row.id
            console.log(id)
          if (row.id !==''){
            if (row && row.rfqId) {
              getQuotationDetail({}, row.rfqId).then(data => {
                if (data && data.code === '00') {
                  if("2" != data.body.rfqStatus) {
                      this.$message.warning("询价单不是询价中状态，不允许删除报价相关信息")
                  } else {
                    this.$confirm(`确定进行删除操作?`, '提示', {
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                      type: 'warning'
                    }).then(() => {
                      removeRfqQuotationConversion({}, id).then(data => {
                        if (data && data.code === '00') {
                          this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                              this.getDataList()
                            }
                          })
                        } else {
                          this.$message.error(data.msg)
                        }
                      })
                    })
                  }
                }
              })
            }

          }else {
            //未保存的 直接删除行
            // console.log(JSON.stringify(row))
            var a = []
            a.push(row)
            this.editTable.delRows(a)
          }

        },
      //保存
      save(){
        var ins =[]
        var upd=[]
        this.dataList.forEach(value => {
          if (value.id !==''){
            upd.push(value)
          }else {
            ins.push(value)
          }
        })
        if (ins.length > 0 ){
          var params = {
            "list":ins,
            "rfqId": this.dataForm.rfqId,
            "subcompanyId": this.dataFromParent.subcompanyId
          }
          this.saveDisabled = true
          createRfqQuotationConversionBatch(params).then(data => {
            if (data && data.code === '00') {
              // this.dataForm = data.body
              this.$message({
                message: '操作成功',
                type: 'success',
              })
            } else {
              this.$message.error(data.msg)
            }
            this.getDataList()
            setTimeout(() => {
                this.saveDisabled = false
            }, 3000)
          })
        }
        // if (upd.length > 0 ){
        //   var params = {
        //     "list":upd
        //   }
        //   editRfqQuotationConversionBatch(params).then(data => {
        //     if (data && data.code === '00') {
        //       this.dataForm = data.body
        //       this.$message({
        //         message: '操作成功',
        //         type: 'success',
        //       })
        //     } else {
        //       this.$message.error(data.msg)
        //     }
        //   })
        //
        // }
        //   this.getDataList()
      },
    }
}
</script>

<style lang="scss">
.button-danger {
    color: #F56C6C
}

.text-danger {
    color: #F56C6C
}

.text-success {
    color: #67C23A
}

.text-waming {
    color: #E6A23C;
}

.text-info {
    color: #909399;
}

.fr {
    float: right;
}
</style>
